import { elements, mqList, isNavVisible } from './base';

// Collapse the main navigation if on moblie screens or scolled down from the top
export function collapseMainNav() {
  const { navWrap, navCheckbox, navButton, navBackground, navBar, navList } =
    elements;

  if (navWrap) {
    navCheckbox.checked = false;

    mqList.small.matches // Collapse Navigation on mobiles
      ? addCollapseClass()
      : isNavVisible() // Collapse when the navigation is invisible
      ? removeCollapseClass()
      : addCollapseClass();
  }

  function addCollapseClass() {
    navButton.classList.add('collapse');
    navBackground.classList.add('collapse');
    navBar.classList.add('collapse');
    navList.classList.add('collapse');
  }

  function removeCollapseClass() {
    navButton.classList.remove('collapse');
    navBackground.classList.remove('collapse');
    navBar.classList.remove('collapse');
    navList.classList.remove('collapse');
  }
}

// Add the active class if the current page is index.html/about.html
export function addActiveClass() {
  const { navItems } = elements;
  const currentURL = window.location.pathname;
  // 1. Get current active element
  const currentEl = document.querySelector('.active');
  // 2. Remove the active class
  if (currentEl) current.classList.remove('active');
  // 3. Add active only on the Work and About pages
  switch (currentURL) {
    case '/':
    case '/index.html':
    case '/dist/index.html': // production on the local server
      navItems[0].classList.add('active');
      break;
    case '/about.html':
    case '/dist/about.html': // production on the local server
      navItems[1].classList.add('active');
    default:
      return;
  }
}
